let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("cym6o")).then(() => parcelRequire('bq5MD'));